// LeaderboardSkeleton.jsx
import React from "react";
import Skeleton from "../../../CommonComponents/Skeleton"; 

const LeaderboardSkeleton = ({ count = 3 }) => {  // Changed default to 3 to match picture
  return (
    <>
      {[...Array(count)].map((_, index) => (
        <div key={index} className="skeleton-leaderboard-item" style={{ display:"flex",flexDirection:"row"}}>
          <Skeleton
            variant="circular"
            width={40}
            height={40}
            style={{ flexShrink: 0 }}
          />

          <Skeleton
            variant="text"
            width="100%"
            height={40}
            style={{ 
              flex: 1,
              marginLeft: "12px",
              marginRight: "12px",
            }}
          />

          <div className="leaderboard-score" style={{ alignItems: "flex-end" }}>
            <Skeleton 
              variant="text"
              width={50} 
              height={24} 
            />
            <Skeleton 
              variant="text"
              width={40} 
              height={24} 
            />
          </div>
        </div>
      ))}
    </>
  );
};

export default LeaderboardSkeleton;